import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/vercel/path0/components/layout/Header.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/motion/Reveal.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
